export const Channel = {
    unknown: 'unknown',
    admin: 'admin',
    kiosk: 'kiosk',
    desktopBrowser: 'desktopBrowser',
    mobileBrowser: 'mobileBrowser',
    mobileApp: 'mobileApp',
    browser: 'browser',
};
export const PaymentStatus = {
    initiated: 'initiated',
    authorized: 'authorized',
    captured: 'captured',
    failed: 'failed',
    refunded: 'refunded',
    cancelled: 'cancelled',
};
export const AggregatedPaymentStatus = {
    notPrepaid: 'notPrepaid',
    paymentInitiated: 'paymentInitiated',
    paymentAuthorized: 'paymentAuthorized',
    paymentCaptured: 'paymentCaptured',
    paymentFailed: 'paymentFailed',
    paymentRefunded: 'paymentRefunded',
    paymentCancelled: 'paymentCancelled',
    notFound: 'paymentNotFound',
    error: 'error',
};
export const OrderStatus = {
    pending: 'pending',
    confirmed: 'confirmed',
    rejected: 'rejected',
    basket: 'basket',
    pending_additional_payment: 'pending_additional_payment',
};
export const CreatedBy = {
    customer: 'customer',
    manager: 'manager',
    admin: 'admin',
    system: 'system',
};
export const SentBy = {
    customer: 'customer',
    manager: 'manager',
    admin: 'admin',
};
export const OrderPaymentStatus = {
    postpaid: 'postpaid',
    prepaid: 'prepaid',
};
export const DiscountType = {
    twoForOne: 'twoForOne',
    simpleDiscountInPct: 'simpleDiscountInPct',
    simpleDiscountFixedAmount: 'simpleDiscountFixedAmount',
    globalDiscountWithMax: 'globalDiscountWithMax',
    bulkDiscount: 'bulkDiscount',
    percentDiscount: 'percentDiscount',
    familyDiscount: 'familyDiscount',
};
export const AccountingGateway = {
    viking: 'viking',
    onlinePOS: 'onlinePOS',
    mockAccountingProvider: 'mockAccountingProvider',
};
export const VikingOrder = {
    deposit: 'deposit',
    final: 'final',
    refund: 'refund',
    finalRefund: 'finalRefund',
    customOrder: 'customOrder',
    customRefund: 'customRefund',
};
export const VikingApiVersions = {
    saveReceiptApi: 'saveReceiptApi',
    webOrderApi: 'webOrderApi',
};
export const FeedbackEmail = {
    trustPilot: 'trustPilot',
    surveyXact: 'surveyXact',
};
export const DateRule = {
    creationDate: 'creationDate',
    pickupDate: 'pickupDate',
    paymentDate: 'paymentDate',
};
export const PaymentProviders = {
    Demo: 'demo',
    Bambora: 'bambora',
    Nets: 'nets',
};
export const OnlinePosOrderType = {
    TAW: 1,
    KIOSK: 2,
    BROWSER_APP: 3,
    BROWSER_APP_SUBSCRIPTION: 4,
    MOBILE_APP_SUBSCRIPTION: 10,
    MOBILE_APP: 11,
    KIOSK_SUBSCRIPTION: 13,
    KIOSK_SUBSCRIPTION_EMPLOYEE: 14,
    SUNSET_PLUS_EMPLOYEE: 9,
    SUNSET_PLUS_APP_EMPLOYEE: 12,
    DRIVE_IN_APP: 17,
    DRIVE_IN_SUBSCRIPTION: 18,
    DRIVE_IN_EMPLOYEE: 19,
    BROWSER_APP_SUNSETPOINTS: 20,
    MOBILE_APP_SUNSETPOINTS: 21,
    KIOSK_SUNSETPOINTS: 22,
    DRIVE_IN_SUSETPOINTS: 23,
    DRIVE_THROUGH_BROWSER_MOBILE: 24,
    DRIVE_THROUGH_BROWSER_DESKTOP: 25,
    DRIVE_THROUGH_APP: 26,
    DRIVE_THROUGH_APP_PLUS: 27,
    DRIVE_THROUGH_APP_POINT: 28,
    DRIVE_THROUGH_BROWSER_MOBILE_PLUS: 29,
    DRIVE_THROUGH_BROWSER_MOBILE_POINT: 30,
    DRIVE_THROUGH_BROWSER_DESKTOP_PLUS: 31,
    DRIVE_THROUGH_BROWSER_DESKTOP_POINT: 32,
    DRIVE_THROUGH_BROWSER_MOBILE_EMPLOYEE: 33,
    DRIVE_THROUGH_BROWSER_DESKTOP_EMPLOYEE: 34,
    DRIVE_THROUGH_APP_EMPLOYEE: 35,
};
export const CUSTOMER_TYPES = Object.freeze({
    GUESTS: 'guests',
    POINT_MEMBERS: 'pointMembers',
    PLUS_MEMBERS: 'plusMembers',
});
